import { FC } from 'react';
import { Button, Icons, Theme, Typography } from 'team-hero-ui';
import { useTranslation } from 'react-i18next';

import type { IFormProps } from './Form.types';
import {
  ButtonsWrapperStyled,
  FormDescriptionStyled,
  FormStyled,
  FormSubTitleStyled,
  FormTitleStyled,
} from './Form.styled';

const TABLE_SVG_SIZES = {
  '10': 10,
  '15': 15,
  '20': 20,
};

export const Form: FC<IFormProps> = ({
  children,
  isLastStep,
  title,
  onNextClick,
  onBackClick,
  disabled = false,
}) => {
  const { t } = useTranslation();

  return (
    <FormStyled>
      <FormTitleStyled>
        <Typography.H1 type='secondary'> {t('jobAdForm.title')}</Typography.H1>
      </FormTitleStyled>
      <FormDescriptionStyled>
        <Typography.Copy size='M'>{t('basics.description')}</Typography.Copy>
      </FormDescriptionStyled>
      {title && (
        <FormSubTitleStyled>
          <Typography.H3>{title}</Typography.H3>
        </FormSubTitleStyled>
      )}
      {children}
      <ButtonsWrapperStyled>
        {onBackClick ? (
          <Button
            color='secondary'
            onClick={onBackClick}
            startIcon={
              <Icons.ArrowLeftIcon
                svgColor={Theme.colors.primary.grey}
                svgSize={TABLE_SVG_SIZES[20]}
              />
            }
          >
            {t('button.back')}
          </Button>
        ) : (
          <div />
        )}
        <Button
          color='grey'
          size='large'
          disabled={disabled}
          onClick={onNextClick}
          endIcon={
            !isLastStep && (
              <Icons.ArrowRightIcon
                svgColor={Theme.colors.primary.white}
                svgSize={TABLE_SVG_SIZES[20]}
              />
            )
          }
        >
          {isLastStep ? t('button.applyNow') : t('button.continue')}
        </Button>
      </ButtonsWrapperStyled>
    </FormStyled>
  );
};
